import { useState, useEffect } from 'react';
import { deadlineCountdown } from '@/lib/eastern';

// Editor-facing deadline as a fixed-instant countdown. Timezone-proof: the
// target is a fixed UTC instant (end of the due day, US Eastern), so this reads
// correctly even on a browser set to the wrong timezone. Re-renders every 60s.
export const DeadlineCountdown = ({ dueDate, className = '', testId }) => {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 60000);
    return () => clearInterval(id);
  }, []);

  const cd = deadlineCountdown(dueDate);
  if (!cd) return null;

  const color = cd.overdue
    ? 'text-velvet-burgundy'
    : cd.soon
    ? 'text-ug-gold'
    : 'text-slate-400';

  return (
    <span
      data-testid={testId}
      className={`font-sans text-[11px] font-medium ${color} ${className}`}
      title={`Deadline: end of ${dueDate} (US Eastern)`}
    >
      {cd.text}
    </span>
  );
};

export default DeadlineCountdown;
